import React from "react";
import { useMediaQuery } from "../../common/hooks/use-media-query";

const Services = () => {
  const isRow = useMediaQuery("(min-width: 1000px)");

  return (
    <section id="services" className="tc-services-style1">
      <div className="content section-padding section-padding-x">
        <div className="container">
          <div className="title mb-80 text-center">
            <p className="color-666 text-uppercase wow"> our services </p>
          </div>
          <div className="services">
            <div className="row">
              <div className="col-lg-3">
                <div
                  className="service-card wow fadeInUp"
                  data-wow-delay="0.2s"
                >
                  <div className="icon">
                    <i className="la la-hard-hat"></i>
                  </div>
                  <h5 className="fsz-24 mb-20"> Architecture & Building </h5>
                  <div className="img">
                    <img
                      src="/home1/assets/img/services/ser1.webp"
                      alt=""
                      className="img-cover"
                    />
                  </div>
                  <div className="text color-666 mt-50">
                    At Tameer, we create buildings that balance innovation with
                    cultural sensitivity. Our services include comprehensive
                    planning, 3D visualization, landscape design, and structural
                    drawing. Each structure is crafted to enhance its
                    surroundings, combining visual appeal with structural
                    integrity to leave a lasting impact on the community.
                  </div>
                  {/* <span className="arrow">
                    <i className="ti-arrow-top-right"></i>
                  </span> */}
                </div>
              </div>
              <div className="col-lg-3">
                <div
                  className="service-card mt-150 wow fadeInUp"
                  data-wow-delay={isRow ? "0.4s" : "0.2s"}
                >
                  <div className="icon">
                    <i className="la la-bezier-curve"></i>
                  </div>
                  <h5 className="fsz-24 mb-20">Interior and Exterior Design</h5>
                  <div className="img">
                    <img
                      src="/home1/assets/img/services/ser2.webp"
                      alt=""
                      className="img-cover"
                    />
                  </div>
                  <div className="text color-666 mt-50">
                    Our interior and exterior designs blend functionality with
                    beauty, crafting spaces that reflect our clients’ tastes and
                    needs. From renovations to sustainable design and
                    installations, we bring each vision to life with precision.
                    Our 3D experiences allow clients to visualize their
                    completed spaces, ensuring every detail meets their
                    expectations.
                  </div>
                  {/* <span className="arrow">
                    <i className="ti-arrow-top-right"></i>
                  </span> */}
                </div>
              </div>
              <div className="col-lg-3">
                <div
                  className="service-card wow fadeInUp"
                  data-wow-delay={isRow ? "0.6s" : "0.2s"}
                >
                  <div className="icon">
                    <i className="la la-bed"></i>
                  </div>
                  <h5 className="fsz-24 mb-20"> Furniture Productions </h5>
                  <div className="img">
                    <img
                      src="/home1/assets/img/services/ser3.webp"
                      alt=""
                      className="img-cover"
                    />
                  </div>
                  <div className="text color-666 mt-50">
                    Tameer’s furniture production offers bespoke pieces that
                    elevate any space. Through custom designs, material
                    sourcing, and an online store, we provide high-quality
                    furniture solutions tailored to each client’s style. Every
                    piece is crafted with care, reflecting elegance, durability,
                    and functionality
                  </div>
                  {/* <span className="arrow">
                    <i className="ti-arrow-top-right"></i>
                  </span> */}
                </div>
              </div>
              <div className="col-lg-3">
                <div
                  className="service-card mt-150 wow fadeInUp"
                  data-wow-delay={isRow ? "0.8s" : "0.2s"}
                >
                  <div className="icon">
                    <i className="la la-comments"></i>
                  </div>
                  <h5 className="fsz-24 mb-20">
                    Project Consulting & Supervisor
                  </h5>
                  <div className="img">
                    <img
                      src="/home1/assets/img/services/ser4.webp"
                      alt=""
                      className="img-cover"
                    />
                  </div>
                  <div className="text color-666 mt-50">
                    Our project consultation and supervision services ensure a
                    smooth journey from concept to completion. We begin with a
                    detailed survey and design plan, including technical
                    drawings, and 3D visuals. Our team oversees each stage with
                    precision, delivering a transparent, seamless experience
                    that brings our clients’ visions to life.
                  </div>
                  {/* <span className="arrow">
                    <i className="ti-arrow-top-right"></i>
                  </span> */}
                </div>
              </div>
            </div>
          </div>
          {/* <div className="text-center">
            <a
              href="#"
              className="butn rounded-pill mt-80 hover-bg-black bg-primary-custom text-white"
            >
              <span>
                View Company Profile
                <i className="small ms-1 ti-arrow-top-right"></i>
              </span>
            </a>
          </div> */}
        </div>
      </div>
      <div className="ser-img">
        <img src="/home1/assets/img/services/ser.webp" alt="" />
      </div>
    </section>
  );
};

export default Services;
